import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { type IRecurrencePattern } from '@principle-theorem/shared';
import { RecurrenceFormComponent } from '../recurrence-form/recurrence-form.component';

@Component({
  selector: 'pr-recurrence-dialog',
  templateUrl: './recurrence-dialog.component.html',
  styleUrls: ['./recurrence-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, RecurrenceFormComponent],
})
export class RecurrenceDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<
      RecurrenceDialogComponent,
      IRecurrencePattern
    >,
    @Inject(MAT_DIALOG_DATA)
    public recurrencePattern: Partial<IRecurrencePattern>
  ) {}

  submitted($event: IRecurrencePattern): void {
    this.dialogRef.close($event);
  }
}
